import { UnregisteredUserActionType, UnregisteredUserActions as Actions } from 'redux/actions/unregisteredUser'
import produce from 'immer'
import { UnregisteredUserState, FetchRequestState } from 'types'

export const initialState = {
  status: FetchRequestState.Idle,
  bannerDismissed: false,
}

export default function unregisteredUserReducer(
  state: UnregisteredUserState = initialState,
  action: UnregisteredUserActionType,
): UnregisteredUserState {
  switch (action.type) {
    case Actions.AUTHENTICATE_START:
      return produce(state, (draft) => {
        draft.status = FetchRequestState.Loading
        draft.headers = undefined
        draft.user = undefined
      })

    case Actions.AUTHENTICATE_SUCCESS:
      return produce(state, (draft) => {
        draft.status = FetchRequestState.Resolved
        draft.headers = { authorization: action.payload.authHeader }
        draft.user = action.payload.user
      })

    case Actions.AUTHENTICATE_FAILURE:
      return produce(state, (draft) => {
        draft.status = FetchRequestState.Rejected
        draft.headers = undefined
        draft.user = undefined
      })

    case Actions.DISMISS_BANNER:
      return produce(state, (draft) => {
        draft.bannerDismissed = true
      })

    case Actions.SET_NAME:
      return produce(state, (draft) => {
        if (draft.user) {
          draft.user.first_name = action.payload.first_name
          draft.user.last_name = action.payload.last_name
        }
      })

    case Actions.UNSET:
      return initialState

    default:
      return state
  }
}
